export const environment = {
  production: true,
  baseURL: 'https://app.demo-platform.theloops.ai/v1',
  envName: 'demo-platform',
  cubejsURL: 'https://app.demo-platform.theloops.ai/cubejs-api/v1',
  /** Cube.js JWT for analytics API (from /teams/authorize) */
  cubeJsToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRJZCI6InNhbmRib3giLCJhcHBJZCI6IjIiLCJ1c2VySWQiOiI1OTkyNDcwMzk5Mjc4MTk5NTQzIiwiaXNDU01Vc2VyIjpmYWxzZSwiaW1wbGljaXRGaWx0ZXJzIjpbXSwidXNlQnVzaW5lc3NIb3VycyI6ZmFsc2UsImN1c3RvbWVySWRzRmlsdGVyIjpbXSwiaWF0IjoxNzcyMDExMzc5LCJleHAiOjE3NzQ2MDMzNzl9.XVs54JWEFqnrc6nQ0-8ZFsDjmAa3YrF4zBTA3bRulsQ',
  /** Auth JWT for REST API calls (from /teams/authorize) */
  authToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ii0xOTQwODc4NzkxNDIzMzMyMDk3IiwibmFtZSI6IkFrc2hheSBCYWJhciIsInRlbmFudElkIjoic2FuZGJveHFhIiwicm9sZSI6IlRlYW1zQm90QXBwVXNlciIsImlhdCI6MTc3MjA0MjUwMiwiZXhwIjoxNzcyMjE1MzAyfQ.Np6zpwRAbjDKlTd9AvQSANEINXzUb1pw71NJEJdoMQ4',
  /** Default app ID for API paths (from /teams/authorize) */
  appId: '2',
  agentHomepageBaseUrl: 'https://agenthomepage.demo-platform.theloops.ai',
  reactAppBaseUrl: 'https://#tenantId#.demo-platform.theloops.ai',
};
